import { render, staticRenderFns } from "./zhiyanWssAdmin.vue?vue&type=template&id=28167948&scoped=true&"
import script from "./zhiyanWssAdmin.vue?vue&type=script&lang=js&"
export * from "./zhiyanWssAdmin.vue?vue&type=script&lang=js&"
import style0 from "./zhiyanWssAdmin.vue?vue&type=style&index=0&id=28167948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28167948",
  null
  
)

export default component.exports